import Button from "components/semantic/Button";
import Input from "components/semantic/Input";
import Card from "components/common/Card";
import { useFormik } from "formik";
import { loginSchema } from "config/schema";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { createUserThunk, getPartnerData } from "store/thunk/main.thunk";
import { useEffect, useState } from "react";

interface initialValuesTypes {
  polHolderName: string;
  polHolderEmail: string;
  polHolderPhone: string;
}

const initialValues: initialValuesTypes = {
  polHolderName: "",
  polHolderEmail: "",
  polHolderPhone: ""
};

const Login = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [partnerData, setPartnerData] = useState("");
  const isLoading = useAppSelector((state) => state.rootReducer.mainSlice.loginLoading);

  const coupon = searchParams.get("coupon");

  useEffect(() => {
    const src = searchParams.get("src");
    if (src) {
      fetchPartnerHandler(src);
    } else sessionStorage.removeItem("src");

    if (coupon) localStorage.setItem("coupon", coupon);
    else localStorage.removeItem("coupon");
  }, []);

  const fetchPartnerHandler = (src: string) => {
    dispatch(getPartnerData(src))
      .unwrap()
      .then((data) => {
        if (data?.success) {
          setPartnerData(data?.data?._id);
          sessionStorage.setItem("src", data?.data?._id);
        }
      });
  };

  const { values, handleSubmit, handleChange, touched, errors }: any = useFormik({
    initialValues: initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values: any) => {
      values = { ...values, polHolderPhone: String(values.polHolderPhone) };

      if (partnerData) values.userCreatedBy = partnerData;
      dispatch(createUserThunk(values))
        .unwrap()
        .then((data: any) => {
          if (data.success) {
            navigate("/otp");
          }
        });
    }
  });

  const inputProps = { onChange: handleChange, errors: errors, touched: touched };

  return (
    <div>
      <h1 className="text-2xl font-extrabold mb-6">User Details</h1>

      <Card className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9 gap-y-4 md:gap-y-8 p-6 md:p-10 w-full">
          <Input label="Policyholder Name *" type="text" name="polHolderName" value={values.polHolderName} placeholder="Policyholder Name" {...inputProps} />
          <Input label="Mobile Number *" limit={10} type="number" name="polHolderPhone" value={values.polHolderPhone} placeholder="Enter Mobile Number" {...inputProps} />
          <Input label="Email Address *" type="email" name="polHolderEmail" value={values.polHolderEmail} placeholder="Enter Email Address" {...inputProps} />
        </div>
        <hr />
        <div className="flex justify-center py-5">
          <Button type="submit" title="NEXT" onClick={handleSubmit} isLoading={isLoading} />
        </div>
      </Card>
    </div>
  );
};

export default Login;
